import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useDisplayAllFaults = createGlobalState({
  storage: "session",
  key: "useDisplayAllFaults",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
